export const visitorSiteConfig = {
  siteId: "joie",
  siteName: "Joie",
  excludedPathPrefixes: [],
} as const;
